/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Spanish (International)
export default {
  'fabric.elements.mentions.team.member.50plus': 'Equipo • Más de 50 miembros',
  'fabric.elements.mentions.team.member.50plus.including.you': 'Equipo • Más de 50 miembros, incluyéndote a ti',
  'fabric.elements.mentions.team.member.count': '{0, plural, one {Equipo • 1 miembro} other {Equipo • {0} miembros}}',
  'fabric.elements.mentions.team.member.count.including.you': '{0, plural, one {Equipo • 1 miembro, incluyéndote a ti} other {Equipo • {0} miembros, incluyéndote a ti}}',
  'fabric.elements.mentions.xproduct.mention.description': 'Necesita acceso a Confluence',
  'fabric.mention.error.defaultAction': 'Vuelve a intentarlo en unos segundos',
  'fabric.mention.error.defaultHeadline': 'Algo ha ido mal',
  'fabric.mention.error.differentText': 'Prueba a escribir otro texto',
  'fabric.mention.error.loginAgain': 'Prueba a cerrar y abrir sesión de nuevo',
  'fabric.mention.noAccess.label': 'Sin acceso',
  'fabric.mention.noAccess.warning': '{name} no recibirá una notificación porque no tiene acceso',
  'fabric.mention.unknow.user.error': 'Usuario desconocido {userId}'
};